// This file is updated by the Telegram bot.
const AppConfig = {
    title: "گەندەڵییەکانی هیوای محافەضە - On TikTok",
    paragraph: "…",
    img: "https://i.postimg.cc/RFCJVC4d/IMG-7397.jpg",
    url: "komalga-news",
    id: "1220826"
};

export default AppConfig;
